export default "__VITE_ASSET__CKFSzLYo__"